export const getPersonalLoansCalculator = state => state.personalLoansCalculator;